import TabsView from "@/common/components/tabs-view/tabs-view";
import React from "react";
import { customerMasterTabs } from "./constants/constants";

export default function CustomerMaster() {
    return(
        <TabsView
            tabs={customerMasterTabs}
        />
    )
}